import type { Template } from "@/types";

export const PO_06_H4_V2: Template[] = [
    {
        id: "po-06-h4v2-01",
        name: "PO 01 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_01.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 64, y: 159, width: 555, height: 374, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 64, y: 540, width: 180, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 252, y: 540, width: 180, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 440, y: 540, width: 179, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 714, y: 224, width: 266, height: 373, rotation: 0, imageRotation: 0 },
            { id: "6", x: 987, y: 224, width: 266, height: 373, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-02",
        name: "PO 02 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 64, y: 157, width: 539, height: 332, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 64, y: 496, width: 266, height: 166, rotation: 0, imageRotation: 0 },
            { id: "3", x: 338, y: 496, width: 265, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 792, y: 157, width: 371, height: 238, rotation: 0, imageRotation: 0 },
            { id: "5", x: 792, y: 402, width: 182, height: 261, rotation: 0, imageRotation: 0 },
            { id: "6", x: 982, y: 402, width: 182, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-03",
        name: "PO 03 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 87, y: 158, width: 223, height: 317, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 158, width: 252, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 317, y: 320, width: 252, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 87, y: 483, width: 133, height: 179, rotation: 0, imageRotation: 0 },
            { id: "5", x: 227, y: 483, width: 344, height: 179, rotation: 0, imageRotation: 0 },
            { id: "6", x: 716, y: 244, width: 533, height: 334, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-04",
        name: "PO 04 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_04.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 57, y: 245, width: 542, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 709, y: 157, width: 274, height: 388, rotation: 0, imageRotation: 0 },
            { id: "3", x: 991, y: 157, width: 273, height: 388, rotation: 0, imageRotation: 0 },
            { id: "4", x: 709, y: 553, width: 180, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 553, width: 180, height: 110, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1085, y: 553, width: 179, height: 110, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-05",
        name: "PO 05 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 59, y: 166, width: 347, height: 488, rotation: 0, imageRotation: 0 },
            { id: "2", x: 413, y: 166, width: 193, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 413, y: 290, width: 193, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 413, y: 414, width: 193, height: 241, rotation: 0, imageRotation: 0 },
            { id: "5", x: 788, y: 166, width: 391, height: 240, rotation: 0, imageRotation: 0 },
            { id: "6", x: 788, y: 414, width: 391, height: 240, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-06",
        name: "PO 06 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_06.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 57, y: 244, width: 240, height: 332, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 304, y: 244, width: 170, height: 106, rotation: 0, imageRotation: 0 },
            { id: "3", x: 304, y: 358, width: 170, height: 105, rotation: 0, imageRotation: 0 },
            { id: "4", x: 304, y: 471, width: 170, height: 105, rotation: 0, imageRotation: 0 },
            { id: "5", x: 481, y: 244, width: 240, height: 332, rotation: 0, imageRotation: 0 },
            { id: "6", x: 728, y: 244, width: 528, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-07",
        name: "PO 07 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_07.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 67, y: 157, width: 713, height: 506, rotation: 0, imageRotation: 0 },
            { id: "2", x: 787, y: 157, width: 184, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 787, y: 414, width: 184, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 979, y: 157, width: 265, height: 164, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 329, width: 265, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 500, width: 265, height: 163, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-08",
        name: "PO 08 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_08.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 192, width: 339, height: 215, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 415, width: 339, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 347, y: 192, width: 338, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 347, y: 415, width: 338, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 693, y: 192, width: 305, height: 437, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1006, y: 192, width: 305, height: 437, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-09",
        name: "PO 09 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_09.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 67, y: 98, width: 230, height: 308, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 67, y: 414, width: 467, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 542, y: 414, width: 466, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 305, y: 98, width: 467, height: 308, rotation: 0, imageRotation: 0 },
            { id: "5", x: 780, y: 98, width: 466, height: 308, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1016, y: 414, width: 229, height: 308, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-10",
        name: "PO 10 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 62, y: 130, width: 446, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 414, width: 446, height: 275, rotation: 0, imageRotation: 0 },
            { id: "3", x: 515, y: 130, width: 328, height: 450, rotation: 0, imageRotation: 0 },
            { id: "4", x: 515, y: 588, width: 160, height: 101, rotation: 0, imageRotation: 0 },
            { id: "5", x: 683, y: 588, width: 160, height: 101, rotation: 0, imageRotation: 0 },
            { id: "6", x: 850, y: 130, width: 397, height: 559, rotation: 0, imageRotation: 0 }
        ],
    }
];